// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-Fg9lKB","toast":"toast-YYIAQC"};